// Date filter constants
export const NO_END_DATE = 'unlimited';
export const DATE_RANGE_FORMAT = 'D MMM YYYY';

// Filter fixed values
export const CanonicalFurniture = {
  Furnished: 'furnished',
  Unfurnished: 'unfurnished',
};

export const CanonicalBills = {
  Included: 'included',
  Excluded: 'excluded',
};

export const CanonicalRegistration = {
  Possible: 'possible',
  NotPossible: 'not-possible',
};

// Registration filter only shown for these country codes.
export const RegistrationCountryCodes = ['nl', 'be', 'de', 'at', 'dk'];

export const MobileFiltersModalName = 'mobileFilters';
